const COUNTRIES = {
  USA: 'USA',
  VN: 'VN',
};

export const ALL_COUNTRIES = 'all countries';
export const ALL_SUPPLIERS = 'all suppliers';

export default COUNTRIES;
